// extracted by mini-css-extract-plugin
module.exports = {"container":"rich-text-wrapper_container__mztFg"};